<template>
  <el-dialog title="编辑求职意向" :close-on-click-modal="false" :visible.sync="display" top="10vh" @close="closeDialog">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <span class="workedit">
        <el-form-item label="工作性质" prop="job_nature_ids">
          <el-checkbox-group v-model="form.job_nature_ids">
            <el-checkbox v-for="item in job_natures" :key="item.value" :label="item.value">
              {{item.label}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="意向城市" prop="city_ids">
          <el-select v-model="form.city_ids" :disabled="isFineMember && form.city_ids &&  form.city_ids.length > 0" multiple placeholder="请选择（可多选）" style="width:100%;" @click.native="onClickEditExpectCity">
            <el-option v-for="item in cityOption" :key="item.id" :label="item.city" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="意向职能" prop="position_ids">
          <el-cascader v-model="position_id_list" :options="positions" :props="positionProps" :show-all-levels="false"
            placeholder="请选择（可多选）" style="width:100%;" @change="onPositionChange"></el-cascader>
        </el-form-item>
      </span>
      <span class="workedit">
        <el-form-item label="期望月薪" prop="min_salary">
          <el-row>
            <el-input v-model="form.min_salary" style="float:left; width:73px"></el-input>
            <span style="float:left; margin:0 10px;">-</span>
            <el-input v-model="form.max_salary" style="float:left; width:160px"><template slot="append">千元/月</template>
            </el-input>
          </el-row>
        </el-form-item>
      </span>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="confirm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {
    getMeCityList,
    getPositionList
  } from '~/api/common';
  import { checkFineMember } from '~/api/me';

  export default {
    components: {
    },
    props: {
      data: {
        type: Object,
        default: {}
      },
      visible: {
        type: Boolean,
        default: false
      }
    },
    data() {
      const checkSalarys = (rule, value, callback) => {
        if (!(this.form.min_salary > 0 && this.form.max_salary > 0)) {
          callback(new Error('请输入期望月薪'));
        } else {
          callback();
        }
      };
      return {
        form: {
          job_nature_ids: [],
          position_ids: [],
          min_salary: 0,
          max_salary: 0,
          month_salary: 0,
          eduMode_id: ''
        },
        isFineMember: false,
        display: false,
        salarys: [1, 1], //期望月薪
        job_natures: [{
          value: 11,
          label: '全职'
        }, {
          value: 12,
          label: '兼职'
        }, {
          value: 13,
          label: '实习'
        }],
        positions: [],
        positionProps: {
          multiple: true,
          value: 'id',
          label: 'text',
          children: 'child'
        },
        cityOption: [], //会员求职城市列表
        position_id_list: [],
        rules: {
          city_ids: [{
            required: true,
            message: '请选择意向城市',
            trigger: 'change'
          }],
          min_salary: [{
            required: true,
            validator: checkSalarys,
            trigger: 'change'
          }],
          job_nature_ids: [{
            required: true,
            message: '请选择工作性质',
            trigger: 'change',
            type: 'array'
          }],
          position_ids: [{
            required: true,
            message: '请输入意向职能',
            trigger: 'change',
            type: 'array'
          }]
        }
      };
    },
    watch: {
      data: function (value) {
        this.Init(value);
      },
      visible: function (value) {
        this.display = value;
        this.Init(this.$props.data);
      },
      salarys: function () {
        this.form.min_salary = this.salarys[0];
        this.form.max_salary = this.salarys[1];
      },
    },
    mounted() {
      getMeCityList().then(m => {
        if (m.errcode == 0) {
          this.cityOption = m.data;
        }
      });

      getPositionList().then(m => {
        if (m.errcode == 0) {
          this.positions = m.data;
        }
      });

      this.checkFineMember();
    },
    methods: {
      Init(value) {
        this.form = Object.assign({}, value);
        if (this.form) {
          if (this.form.position_ids) {
            this.position_id_list = this.getPositionFullIds(this.form.position_ids);
          }
        }
      },
      getPositionFullIds(val) {
        if (!val || !Array.isArray(val)) {
          return false;
        }
        var fullIds = [];
        val.forEach(item => {
          var id = parseInt(item / 100) * 100;
          fullIds.push([id, item]);
        });
        return fullIds;
      },
      getPositionSimpleIds(val) {
        if (!val || !Array.isArray(val)) {
          return false;
        }
        var simpleIds = [];
        val.forEach(item => {
          simpleIds.push(item[1]);
        });
        return simpleIds;
      },
      onPositionChange(val) {
        this.form.position_ids = this.getPositionSimpleIds(val);
      },
      getJobNatureName(value) {
        let obj = this.job_natures.find(item => {
          return item.PuBasicdataID === value;
        });
        return typeof obj == 'undefined' ? '' : obj.DaName;
      },
      cancel() {
        this.display = false;
      },
      confirm() {
        this.$refs['form'].validate(valid => {
          if (!valid) return false;
          this.display = false;
          this.$emit('change', this.form);
        });
      },
      closeDialog() {
        this.$emit('visibleChange', false);
      },
      checkFineMember(){
        checkFineMember().then(r => {
          if(r.errcode === 0){
            this.isFineMember = r.data;            
          }
        });
      },
      onClickEditExpectCity(){
        if(this.isFineMember && this.form.city_ids && this.form.city_ids.length > 0){
          this.$message.info('您已经购买了乐跳会员套餐，无法修改求职城市');
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .line {
    border-top: 1px #e0e0e0;
  }
</style>